import { AxiosPromise } from 'axios';

import API_URLS from '@Constants/apiUrls.constants';
import { DncList } from '@Models/dnc.models';

import axiosInstance from './axiosInstance.service';
import TokenService from './token.service';

export default {
  exportDncRows: (body: DncList, isGlobal: boolean): AxiosPromise => {
    const url = `${
      isGlobal ? `${API_URLS.DNC.GLOBAL_DNC}` : `${API_URLS.DNC.BASE_DNC}`
    }`;

    return axiosInstance({
      method: 'POST',
      url: `${url}/${API_URLS.DNC.PHONES}/${API_URLS.DNC.EXPORT}`,
      data: {
        ...body,
        timeZoneOffset: -new Date().getTimezoneOffset(), // BE expects timeZoneOffset with respect to the utc, ie UTC - local time
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenService.getAccessToken() || ''}`,
      },
    });
  },
};
